<template>
  <el-dialog
    append-to-body
    width="600px"
    title="参加招聘会"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item label="已选企业"> {{ list.length }}家</el-form-item>
      <el-form-item prop="fair_id" label="招聘会主题">
        <el-select v-model="form.data.fair_id" clearable placeholder="请选择" filterable>
          <el-option
            v-for="item in zpOpt"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "WealEdit",
  data() {
    return {
      visible: false,
      isChange: false,
      loading: false,
      list: [],
      zpOpt: [],
      form: {
        loading: false,
        data: {
          fair_id: "",
        },
        rules: {
          fair_id: [{ required: true, message: "必填项", trigger: "change" }],
        },
      },
    };
  },
  methods: {
    reset(done) {
      this.isChange = false;
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(list) {
      this.list = list;
      console.log(list);
      // 获取岗位
      this.$http
        .get("/admin/fair/list", { params: { count: 10000 } })
        .then((res) => {
          if (res.code === 1) {
            this.zpOpt = res.data.list;
          }
        });
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let data = {
            id: this.form.data.fair_id,
            company_ids: this.list.map((item) => item.id).join(","),
          };
          this.$http
            .post("/admin/fair/batchAddCompany", data)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$message.success("操作成功");
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
